import React from 'react'
import { Column, DateColumn } from '@sencha/ext-modern'
import {
	DatePickerComponent
	// Inject, MaskedDateTime
} from '@syncfusion/ej2-react-calendars'

import { nullDate } from 'tyan/public/utility'
import { getSyncfusionEditProps } from './utilities'

const render = ({ _date: text, dataIndex, format = 'Y/m/d', align = 'center', handleEdit, edit, ...rest }) => {
	const renderer = (originalValue, record, dataIndex) => {
		const { data: { id } = {}, data } = record || {}
		// 转换为日期格式
		const value = originalValue && originalValue !== nullDate && Tyan.Date.getDateLocal(originalValue) || null
		const handleChange = ({ value }) => {
			value = value ? Tyan.Date.getDateUtcValue(value) : nullDate
			value !== originalValue && handleEdit && handleEdit({ id, name: dataIndex, newValue: value, oldValue: originalValue, data, record, type: 'date' })
		}

		return <div>
			<DatePickerComponent
				// {...props}
				openOnFocus
				showClearButton={false}
				format='y/MM/dd'
				//  enableMask maskPlaceholder={{ year: 'yyyy', month: 'mm', day: 'dd' }}
				// enabled={!disabled}
				value={value}
				change={handleChange} /* focus={handleFocus} blur={handleBlur} */
				{...getSyncfusionEditProps(edit, data)}
			>
				{/* <Inject services={[MaskedDateTime]} /> */}
			</DatePickerComponent>
		</div>
	}

	return edit
		? <Column {...{ dataIndex, text, align, ...rest, renderer, cell: { bodyStyle: { padding: '0px 12px' } } }} />
		: <DateColumn {...{ dataIndex, text, align, format, ...rest }} />
}

export default render